import { FC, ReactNode } from "react";
import useList, { ReceivedProps } from "./hook";
import { Styles } from "./styled";
import AppList from "@lhd/components/CloneApp/pages/AppList";
import { useParams } from "react-router-dom";

interface ListLayoutProps {
  headerExtend?: ReactNode;
  companyId?: number;
}

const ListLayout: FC<ReturnType<typeof useList> & ListLayoutProps> = ({
  headerExtend,
  ...props
}) => {
  return (
    <Styles>
      {headerExtend}
      <AppList quickButtonDirection="vertical" {...props} />
    </Styles>
  );
};

const List: FC<ReceivedProps> = ({
  headerExtend,
  companyIdQuickView,
  ...props
}) => {
  const { id: companyId } = useParams();

  return (
    <ListLayout
      {...useList(props)}
      headerExtend={headerExtend}
      companyId={
        companyIdQuickView ?? (companyId ? Number(companyId) : undefined)
      }
    />
  );
};

export default List;
